import React from 'react';
import { Link } from 'react-router-dom';

import { Button, Stack } from '@eluve/components';

import { FactVerificationWorkflowsList } from './FactVerificationWorkflowsList';

export const FactVerificationIndexPage: React.FC = () => {
  return (
    <div className="mt-4">
      <Stack direction="horizontal" align="center" gap={2}>
        <Link to="workflow/create">
          <Button>Create a Workflow</Button>
        </Link>
      </Stack>
      <FactVerificationWorkflowsList />
    </div>
  );
};
